import React, { useEffect, useState, useRef } from "react";
// import Header from '@/components/header'
import { Bscroll } from "@/components/bscroll";
import html2canvas from "html2canvas";
import {
  createNonceStr,
  md5,
  getLocationSearch,
  getWeekData,
} from "@/utils/utils";
import { CashRuleApi } from "@/api";
import request from "@/utils/request";
import "./index.scss";
import kcfl from "@/assets/images/kcfl.jpg";
const SaveImg = () => {
  //获取token
  let getToken = getLocationSearch().token;
  //响应式数据
  const imgRef = useRef(null);
  //版本判定
  let [isAndroid, setIsAndroid] = useState(false);
  let [isIOS, setIsIOS] = useState(false);
  let [iOSVer, setiOSVer] = useState("");
  //截图dom
  let shareBanner = useRef(null);
  //二维码宽度
  let [QRCodeW, setQRCodeW] = useState(100);
  const handleOnSavePhone = () => {
    // const dom = shareBanner.current.getBoundingClientRect()
    console.log(iOSVer, "iOSVer");
    let y = 0;
    if (isIOS && +iOSVer > 13) {
      y = 550;
    }
    //截图
    html2canvas(shareBanner.current, {
      allowTaint: false,
      useCORS: true,
      scale: 2,
      // imageTimeout : 10000,
      proxy: "https://szxhoss.pokongchuxing.com",
      dpi: window.devicePixelRatio * 2,
      // x: dom.left,
      // y: dom.top,
      // y
    }).then(function (canvas) {
      let d = canvas.toDataURL("image/png");
      //截取只保留base64 字符串
      let packD = d.substring(d.indexOf(",") + 1);
      // 截图成功

      // var u = navigator.userAgent;
      // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
      // var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let params = {
        title: "img",
        url: packD,
      };
      try {
        if (isAndroid) {
          window.savePicture.onSavePicture(packD);
        } else if (isIOS) {
          window.WebViewJavascriptBridge.callHandler("handleSavePhone", params);
        }
      } catch (error) {
        if (!!!navigator.userAgent.match(/citicbankmobile/i)) {
          const a = document.createElement("a");
          a.href = d;
          a.download = "900行开城福利";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    });
  };

  const isComplete = () => {
    console.log(React, "React.colorConfigReact.colorConfig");
    if (imgRef.current.complete) {
      console.log("图片加载完成");
      handleOnSavePhone();
    } else {
      console.log(imgRef.current, "this.$refs.img");
      setTimeout(isComplete, 200);
    }
  };
  //获取数据
  useEffect(() => {
    document.title = "900行开城福利";
    let u = navigator.userAgent;
    let str = navigator.userAgent.toLowerCase();
    setIsAndroid(u.indexOf("Android") > -1 || u.indexOf("Linux") > -1);
    setIsIOS(!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/));
    if (isIOS) {
      let ver = str.match(/cpu iphone os (.*?) like mac os/);
      setiOSVer(ver[1]?.split("_")[0]);
    }
  }, []);

  //   //带Token签名
  //   let appKey = 'app_h5';
  //   let secret = '11dc72cf-88b0-46cd-91d7-b1a77fd69ee1';
  //   let timestamp = new Date().getTime();
  //   let random = createNonceStr();
  //   let token = getToken
  //   let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
  //   let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
  //   request.get(CashRuleApi, {
  //     token: token,
  //   }, {
  //     appKey: appKey,
  //     timestamp: timestamp,
  //     random: random,
  //     token: token,
  //     sign: sign
  //   })
  //     .then((data) => {
  //       if(data.data.errorCode === 0 && data.data.errorMsg === 'SUCCESS'){
  //       }
  //     })
  //   return () => {
  //   }
  // }, [getToken])
  return (
    <div className="save_img__box">
      <div className="save_img__box__show">
        <Bscroll scrollX={false} scrollY={true}>
          <div className="save_img__box_list">
            <div className="share-banner" ref={shareBanner}>
              <div className="banner-img">
                <img ref={imgRef} src={kcfl} alt="" />
              </div>
            </div>
            <div className="share_btn">
              <button
                onClick={isComplete}
                style={React.colorConfig ? React.colorConfig.buttonBg : {}}
              >
                点击保存海报图片<i className="iconfont icon-xiazai"></i>
              </button>
            </div>
          </div>
        </Bscroll>
      </div>
    </div>
  );
};
export default SaveImg;
